<script lang="ts">
import UpsellScreenBox from '@/V2/components/upsell/UpsellScreenBox.vue';
import UpsellScreenMain from '@/V2/components/upsell/UpsellScreenMain.vue';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  name: 'UpsellScreenCompliance',
  components: {
    UpsellScreenBox,
    UpsellScreenMain,
  },
  methods: {
    onPrimaryButtonClicked() {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.UPSELL_BUTTON_CLICKED, {
        button: 'compliance-schedule-call',
      });
      window.open('https://calendar.app.google/2veu2MNaCo9XH7qo6', '_blank');
    },
    onSecondaryButtonClicked() {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.UPSELL_BUTTON_CLICKED, {
        button: 'compliance-learn-more',
      });
      window.open(
        'https://www.inscribe.ai/resources/demo-center/demo-of-the-ai-compliance-analyst',
        '_blank',
      );
    },
  },
};
</script>

<template>
  <div
    class="upsell-screen-compliance d-flex flex-column i-gap-8"
    data-testid="upsell-screen-compliance"
  >
    <!-- main -->
    <upsell-screen-main
      icon="large-ai-spark-scanner"
      title="AI Compliance Analyst (Beta)"
      description="Streamline KYB checks with document analysis and data sources like Secretary of State records. Join the beta for early access and special pricing."
      primary-button-label="Schedule a Call"
      secondary-button-label="Learn More"
      @primary-button-clicked="onPrimaryButtonClicked"
      @secondary-button-clicked="onSecondaryButtonClicked"
    ></upsell-screen-main>

    <!-- boxes -->
    <div class="boxes-container d-flex flex-row i-gap-8">
      <upsell-screen-box
        icon="medium-search-globe"
        title="Incorporation Status"
        description="Verifies the company’s legal status by checking its standing."
      />

      <upsell-screen-box
        icon="medium-browser-check"
        title="Web Presence"
        description="Assesses a company’s online presence and legitimacy."
      />

      <upsell-screen-box
        icon="medium-browser-alert"
        title="Adverse Media"
        description="Identifies negative news associated with the company and beneficial owner."
      />

      <upsell-screen-box
        icon="medium-money-coins"
        title="Transaction Activity"
        description="Analyzes bank transactions to ensure they match the company’s business purpose."
      />

      <upsell-screen-box
        icon="medium-graph-3"
        title="Connection to Company"
        description="Verifies the individual’s business ownership through Secretary of State."
      />

      <upsell-screen-box
        icon="medium-graph-2"
        title="Analyses & Reporting"
        description="Provides clear verdicts for all checks performed and a summary report."
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upsell-screen-compliance {
  max-width: 1200px;
  margin: 0 auto;

  .boxes-container {
    max-width: 100%;
    flex-wrap: wrap;
  }

  :deep(.upsell-screen-box) {
    width: calc(33% - 7px);

    @media screen and (max-width: 1426px) {
      width: calc(50% - 8px);
    }

    @media screen and (max-width: 800px) {
      width: 100%;
    }
  }
}
</style>
